import React from "react";
import { CloudOff, RefreshCw, CloudUpload } from "lucide-react";
import { useOffline } from "@/context/OfflineContext";

export default function OfflineIndicator() {
  const { online, syncing, pendingCount } = useOffline();
  if (online && !syncing && pendingCount === 0) return null;

  let label, Icon, color, spin = false;
  if (syncing) {
    label = `Syncing${pendingCount ? ` ${pendingCount}` : ""}`;
    Icon = RefreshCw; color = "var(--ek-primary)"; spin = true;
  } else if (!online) {
    label = pendingCount ? `Offline · ${pendingCount} queued` : "Offline";
    Icon = CloudOff; color = "var(--ek-warning)";
  } else {
    label = `${pendingCount} to sync`;
    Icon = CloudUpload; color = "var(--ek-primary)";
  }

  return (
    <div data-testid="offline-indicator" title={label}
      className="flex items-center gap-1.5 rounded-md px-2.5 h-9 border text-xs font-medium"
      style={{ borderColor: "var(--ek-border)", color, background: "transparent" }}>
      <Icon className={`h-4 w-4 ${spin ? "animate-spin" : ""}`} />
      <span className="hidden sm:inline">{label}</span>
    </div>
  );
}
